import { createReducer, on } from '@ngrx/store';
import {
  loadCoreApis,
  loadCoreApisSuccess,
  loadCoreApisFailure,
} from './coreapi.actions';

export interface CoreApiState {
  data: any;
  loading: boolean;
  error: any;
}

export const initialState: CoreApiState = {
  data: null,
  loading: false,
  error: null,
};

export const coreApiReducer = createReducer(
  initialState,
  on(loadCoreApis, (state) => ({ ...state, loading: true, error: null })),
  on(loadCoreApisSuccess, (state, { data }) => ({ ...state, loading: false, data })),
  on(loadCoreApisFailure, (state, { error }) => ({ ...state, loading: false, error }))
);
